const UserInfo = ({ user }) => {

  const getRoleLabel = (role) => {
    switch (role) {
      case 1:
        return 'administrátor'
      case 2:
        return 'přijímací technik'
      case 3:
        return 'mechanik'
      default:
        return 'neznámá role'
    }
  }

  return (
    <div className="user-info d-flex align-items-center gap-2 ps-2">
      <i className="bi bi-person fs-4 pt-1 text-primary d-none d-md-block"></i>
      <div className="d-flex flex-column">
        <span className="user-info-name fw-bold lh-1">{user?.jmeno || 'Uživatel'}</span>
        <span className="user-info-role text-muted small">{getRoleLabel(user?.role)}</span>
      </div>
    </div>
  )
}

export default UserInfo
